import map from 'lodash/map'

export const parseProducts = products => {
  return map(products.ds_pro_fat, item => ({
    name: item,
    value: item,
  }))
}
